import ApiService from './api.service'
import TokenService from './storage.service'

class AuthenticationError extends Error {
    constructor( errorCode, message ) {
        super( message )
        this.name = this.constructor.name
        this.message = message
        this.errorCode = errorCode
    }
}

const UserService = {
    /**
     * Sign in the user and store the accessToken to TokenService
     *
     * @constructor
     * @param { string } email - Email
     * @param { string } password - Password
     * @return { string } accessToken
     * @throws { object } AuthenticationError
     */
    signin: async( email, password ) => {
        const requestData = {
            email,
            password
        }

        try {
            const resp = await ApiService.post( 'login', requestData )
            if ( resp.data.accessToken ) {
                TokenService.setToken( resp.data.accessToken )
                TokenService.setRefreshToken( resp.data.refreshToken )
                ApiService.setHeader()
            }
            return resp
        } catch ( err ) {
            throw new AuthenticationError( err.response.status, err.response.data.details )
        }
    },

    /**
     * Refresh the accessToken
     *
     * @return { string } accessToken
     * @throws { object } AuthenticationError
     */
    refreshToken: async() => {
        const refreshToken = TokenService.getRefreshToken()

        const requestData = {
            refreshToken
        }

        try {
            const resp = await ApiService.post( 'refresh', requestData )
            if ( resp.data.accessToken ) {
                TokenService.setToken( resp.data.accessToken )
                TokenService.setRefreshToken( resp.data.refreshToken )
                ApiService.setHeader()
            }
            return resp
        } catch ( err ) {
            throw new AuthenticationError( err.response.status, err.response.data.details )
        }

    },

    /**
     * Logout the user
     *
     * @return {any} none
     */
    logout() {
        TokenService.removeToken()
        TokenService.removeRefreshToken()
        ApiService.removeHeader()
    }

}

export default UserService

export { UserService, AuthenticationError }
